<template>
  <form @submit.prevent="addBundleToCart" novalidate>
    <slot></slot>
  </form>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "product-bundle-single-form",
  props: {
    bundletitle: String,
    bundleprice: [Number, String],
  },
  computed: {
    ...mapGetters({
      getProperties: "metafields/getProperties",
    }),
  },
  methods: {
    async addBundleToCart() {
      const checkbox = document.querySelector(
        'input[data-select-id="id"][type="radio"]:checked'
      );
      const variantIds = checkbox.dataset.vid.split("|");
      const items = variantIds.map((variant) => ({
        id: parseInt(variant),
        properties: this.getProperties(variant),
      }));
      await this.$store.dispatch("cart/addBundleToCart", {
        items,
        bundleProduct: { title: this.bundletitle, price: this.bundleprice },
      });
      await this.$store.dispatch("cart/toggleCart");
    },
  },
};
</script>
